import Roles from "@/router/roles"
import GroupsList from '@/views/Access/Groups/GroupsList'
import GroupDetails from '@/views/Access/Groups/GroupDetails'
import RightsList from '@/views/Access/Rights/RightsList'
import UsersList from '@/views/Access/Users/UsersList'

const accessRoutes = [
    {
        path: '/access/groups',
        name: 'Groups',
        component: GroupsList,
        meta: { authorize: [Roles.Admin, Roles.SuperAdmin, Roles.Editor] },
    },
    {
        path: '/access/groups/:groupId',
        name: "Group details",
        component: GroupDetails,
        meta: { authorize: [Roles.Admin, Roles.SuperAdmin, Roles.Editor] },
    },
    {
        path: '/access/rights',
        name: "Rights",
        component: RightsList,
        meta: { authorize: [Roles.Admin, Roles.SuperAdmin, Roles.Editor] },
    },
    {
        path: '/access/users',
        name: "Users",
        component: UsersList,
        meta: { authorize: [Roles.Admin, Roles.SuperAdmin] },
    }
]

export default accessRoutes;
